import React, { useState } from "react";

export default function FireTruckIsland() {
    const [paused] = useState(false);

    return (

        <div className={"relative w-full overflow-hidden " + (paused ? "is-paused" : "is-running")}>
            <svg
                className="block w-full"
                viewBox="0 0 100.54166 52.916668"
                preserveAspectRatio="xMidYMax meet"
            >
                <defs>
                    {/* Clip voor deurraam (zodat het raam binnen de opening blijft) */}
                    <clipPath id="clip-door-window">
                        <rect x={43.127083} y={7.4083333} width={8.9958334} height={14.816667} />
                    </clipPath>

                    {/* Clips voor luik-openingen */}
                    <clipPath id="clip-luik-1">
                        <rect x={55.033333} y={7.1437497} width={13.229166} height={30.956249} />
                    </clipPath>
                    <clipPath id="clip-luik-2">
                        <rect x={69.585419} y={7.1437497} width={15.08125} height={24.341667} />
                    </clipPath>
                    <clipPath id="clip-luik-3">
                        <rect x={85.724998} y={7.1437497} width={12.964583} height={30.956249} />
                    </clipPath>
                </defs>

                <g id="layer2" className="truck-scale" style={{ display: "inline" }}>
                    {/* Achterwiel back */}
                    <g id="achterwiel-back" transform="translate(48.683334,0.26458334)">
                        <ellipse
                            cx={77.482086}
                            cy={42.539272}
                            rx={5.5688105}
                            ry={7.8661542}
                            transform="translate(-60.341674,-0.55513534)"
                            fill="#000"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                            strokeLinejoin="miter"
                        />
                        <path
                            d="m 71.98334,41.565552 c -0.281257,1.826115 0.24791,4.207365 0.986069,5.571139 1.680222,3.104271 4.134298,3.158461 3.613755,3.240331 -6.458884,1.015838 -8.280118,-3.521797 -8.280118,-7.866154 0,-4.344357 2.493275,-7.880415 5.568811,-7.866154 3.386476,0.0157 3.501382,-0.207097 2.145607,0.33292 -1.401919,0.558396 -3.060727,2.064033 -3.438494,3.819711 -0.198543,0.922736 -0.350008,1.173457 -0.59563,2.768207 z"
                            transform="translate(-60.341674,-0.55513534)"
                            fill="#333"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                        />
                    </g>

                    {/* Zwart blok achterop */}
                    <rect
                        id="rect150579"
                        x={71.172913}
                        y={34.395832}
                        width={11.90625}
                        height={7.9375}
                        fill="#000"
                        stroke="#000"
                        strokeWidth={0.264583}
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                    />

                    {/* Achterwiel front */}
                    <g id="achterwiel-front" transform="translate(42.068751,0.52916667)">
                        <ellipse
                            cx={77.482086}
                            cy={42.539272}
                            rx={5.5688105}
                            ry={7.8661542}
                            transform="translate(-42.085424,-0.55513534)"
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                            strokeLinejoin="miter"
                        />
                        <ellipse
                            cx={35.53907}
                            cy={42.013184}
                            rx={3.3153152}
                            ry={4.1475835}
                            fill="#b2b2b2"
                            stroke="#000"
                            strokeWidth={0.148238}
                        />
                        <ellipse
                            cx={35.3685}
                            cy={41.974361}
                            rx={1.5359924}
                            ry={1.921584}
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.068679}
                        />
                        <path
                            d="m 71.98334,41.565552 c -0.281257,1.826115 0.24791,4.207365 0.986069,5.571139 1.680222,3.104271 4.134298,3.158461 3.613755,3.240331 -6.458884,1.015838 -8.280118,-3.521797 -8.280118,-7.866154 0,-4.344357 2.493275,-7.880415 5.568811,-7.866154 3.386476,0.0157 3.501382,-0.207097 2.145607,0.33292 -1.401919,0.558396 -3.060727,2.064033 -3.438494,3.819711 -0.198543,0.922736 -0.350008,1.173457 -0.59563,2.768207 z"
                            transform="translate(-42.085424,-0.55513534)"
                            fill="#333"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                        />
                    </g>

                    {/* Rode achterkant / opbouw */}
                    <path
                        id="path15339"
                        d="M 41.010416,3.7041666 H 100.27708 V 43.391666 H 83.343749 V 34.395833 H 71.172916 v 8.995833 H 42.068749 l -1.058333,-9.789583 z"
                        fill="#e5352d"
                        stroke="#000"
                        strokeWidth={0.26458333}
                    />

                    {/* Voorwiel back */}
                    <g id="voorwiel-back">
                        <ellipse
                            cx={77.482086}
                            cy={42.539272}
                            rx={5.5688105}
                            ry={7.8661542}
                            transform="translate(-60.341674,-0.55513534)"
                            fill="#000"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                            strokeLinejoin="miter"
                        />
                        <path
                            d="m 71.98334,41.565552 c -0.281257,1.826115 0.24791,4.207365 0.986069,5.571139 1.680222,3.104271 4.134298,3.158461 3.613755,3.240331 -6.458884,1.015838 -8.280118,-3.521797 -8.280118,-7.866154 0,-4.344357 2.493275,-7.880415 5.568811,-7.866154 3.386476,0.0157 3.501382,-0.207097 2.145607,0.33292 -1.401919,0.558396 -3.060727,2.064033 -3.438494,3.819711 -0.198543,0.922736 -0.350008,1.173457 -0.59563,2.768207 z"
                            transform="translate(-60.341674,-0.55513534)"
                            fill="#333"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                        />
                    </g>

                    {/* Zwart driehoekje bij voorwiel */}
                    <path
                        id="path150740"
                        d="m 42.068749,43.391666 h -1.852083 l -3.704166,-9.525 4.497916,-0.264583 1.058333,9.789583"
                        fill="#000"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Voorwiel front */}
                    <g id="voorwiel-front">
                        <ellipse
                            cx={77.482086}
                            cy={42.539272}
                            rx={5.5688105}
                            ry={7.8661542}
                            transform="translate(-42.085424,-0.55513534)"
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.264583}
                        />
                        <ellipse
                            cx={35.53907}
                            cy={42.013184}
                            rx={3.3153152}
                            ry={4.1475835}
                            fill="#b2b2b2"
                            stroke="#000"
                            strokeWidth={0.148238}
                        />
                        <ellipse
                            cx={35.3685}
                            cy={41.974361}
                            rx={1.5359924}
                            ry={1.921584}
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.068679}
                        />
                        <path
                            d="m 71.98334,41.565552 c -0.281257,1.826115 0.24791,4.207365 0.986069,5.571139 1.680222,3.104271 4.134298,3.158461 3.613755,3.240331 -6.458884,1.015838 -8.280118,-3.521797 -8.280118,-7.866154 0,-4.344357 2.493275,-7.880415 5.568811,-7.866154 3.386476,0.0157 3.501382,-0.207097 2.145607,0.33292 -1.401919,0.558396 -3.060727,2.064033 -3.438494,3.819711 -0.198543,0.922736 -0.350008, 1.173457 -0.59563,2.768207 z"
                            transform="translate(-42.085424,-0.55513534)"
                            fill="#333"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                        />
                    </g>

                    {/* Grijs stuk onder voorruit */}
                    <path
                        id="path10372"
                        d="m 22.225,36.247916 1.058333,1.058334 v 6.085416 h 3.96875 l 0.79375,-7.14375 z"
                        fill="#666"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Cabine rood */}
                    <path
                        id="path3107"
                        d="M 38.364583,6.0854166 H 26.722916 l -1.5875,3.7041666 -3.96875,10.5833328 v 15.875 h 6.879167 c 0,0 2.350808,-4.761581 4.497917,-6.085416 2.209207,-1.362122 7.672916,-1.322917 7.672916,-1.322917 l 1e-6,-5.820833 c 0,0 -0.05382,-3.836539 -0.143368,-5.776754 C 39.969096,14.984377 39.945561,12.283122 39.634732,10.42528 39.323903,8.5674395 38.364583,6.0854166 38.364583,6.0854166"
                        fill="#e5352d"
                        stroke="#000"
                        strokeWidth={0.264583}
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                    />

                    {/* Rode onderkant cabine */}
                    <path
                        id="path2779"
                        d="m 1.5875,19.579166 -0.2645834,0.79375 v 15.875 H 21.166666 v -15.875 l 3.96875,-10.5833328 h -0.79375 L 20.6375,19.579166 Z"
                        fill="#ac2822"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Voorruit */}
                    <path
                        id="voorruit"
                        d="m 1.5875,19.579166 h 19.05 L 24.341666,9.7895832 H 5.0270833 Z"
                        fill="#c2ddf1"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Zijruit */}
                    <path
                        id="zijruit"
                        d="M 37.041666,9.7895832 H 26.9875 L 23.283333,19.84375 h 5.027083 l 2.38125,-2.116667 h 6.35 V 9.7895832"
                        fill="#c2ddf1"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Grijze bumper */}
                    <rect
                        id="rect6315"
                        x={0.26458332}
                        y={36.247917}
                        width={23.018749}
                        height={7.6729145}
                        ry={0.90344483}
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Grijze wielkast/onderlijn */}
                    <path
                        id="path7293"
                        d="m 41.010416,28.839583 h -0.79375 c 0,0 -5.530426,-0.01291 -7.65537,1.322605 -2.1314,1.339575 -4.515463,6.085728 -4.515463,6.085728 l -0.79375,6.614583 v 0.529167 h 2.116667 v -0.529167 c 0,0 1.459161,-5.933374 3.704167,-7.672916 2.132877,-1.652659 7.937499,-1.5875 7.937499,-1.5875 v -4.7625"
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Kleine blokjes */}
                    <path
                        id="rect10478"
                        d="m 23.283333,38.099998 4.497917,2e-6 -0.264583,0.79375 -4.233334,-2e-6 z"
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />
                    <rect
                        id="rect10480"
                        x={23.283333}
                        y={40.216667}
                        width={4.2333331}
                        height={0.52916664}
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />
                    <rect
                        id="rect10482"
                        x={23.283333}
                        y={42.862499}
                        width={3.96875}
                        height={0.52916664}
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Rode kaplijn / cabine top */}
                    <path
                        id="path14920"
                        d="M 38.364583,6.0854166 H 26.722916 v -0.79375 h -3.96875 l 10e-7,-1.0583333 18.256249,-0.5291667 V 28.839583 h -0.79375 L 38.364583,6.0854166"
                        fill="#ac2822"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Achterframe onderkant */}
                    <path
                        id="path15972"
                        d="m 71.172916,43.391666 h -1.852084 v -11.1125 h 15.345834 v 11.1125 H 83.343749 V 34.395833 H 71.172916 v 8.995833"
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Verticale rode scheiding */}
                    <path
                        id="path16087"
                        d="M 54.239583,3.7041666 V 43.391666 h -0.79375 v -5.820833 h -0.79375 v -0.79375 h 1.322916 V 3.7041666 h 0.264584"
                        fill="#ac2822"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Zwarte rand bij deur */}
                    <path
                        id="path16250"
                        d="m 42.068749,36.777083 h 10.583334 v 0.79375 H 42.068749 v -0.79375"
                        fill="#000"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Klein grijs steuntje */}
                    <path
                        id="path16248"
                        d="m 41.010416,33.602083 h 0.79375 l 0.79375,9.789583 h -0.529167 z"
                        fill="#989898"
                        stroke="#000"
                        strokeWidth={0.264583}
                    />

                    {/* Oranje strip */}
                    <rect
                        id="rect170122"
                        x={6.6145835}
                        y={39.422916}
                        width={7.6729164}
                        height={1.5875}
                        fill="#ffcc00"
                        stroke="#000"
                        strokeWidth={0.26458333}
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                    />

                    {/* Voorbumper detail */}
                    <path
                        id="path170276-6-2"
                        d="M 6.0854167,32.279167 H 15.08125 l -0.691987,2.910417 H 6.4314101 L 6.0854167,32.279167"
                        fill="#666"
                        stroke="#000"
                        strokeWidth={0.26458333}
                    />

                    {/* Grijs vlak voor */}
                    <path
                        id="path1051"
                        d="M 2.6458333,30.427083 H 19.84375 v -3.175 H 18.520833 L 16.66875,28.575 H 5.8208333 L 3.96875,26.9875 H 2.6458333 Z"
                        fill="#666"
                        stroke="#000"
                        strokeWidth={0.26458333}
                    />

                    {/* Deur + raam (wit + blauw schuift) */}
                    <g id="g8542">
                        {/* Deur */}
                        <rect
                            x={42.333332}
                            y={6.3499999}
                            width={10.583335}
                            height={19.579166}
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.264583}
                            strokeLinecap="round"
                        />

                        {/* Achtergrond raam */}
                        <g clipPath="url(#clip-door-window)">
                            <rect
                                x={43.127083}
                                y={7.4083333}
                                width={8.9958334}
                                height={14.816667}
                                fill="#fff"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />

                            {/* Docker logo (onder het glas) */}
                            <g
                                id="logos-door"
                                transform="translate(44 10) scale(0.0096)"
                                opacity={1}
                            >
                                <path
                                    fill="#1d63ed"
                                    d="M743.96,245.25c-18.54-12.48-67.26-17.81-102.68-8.27-1.91-35.28-20.1-65.01-53.38-90.95l-12.32-8.27-8.21,12.4c-16.14,24.5-22.94,57.14-20.53,86.81,1.9,18.28,8.26,38.83,20.53,53.74-46.1,26.74-88.59,20.67-276.77,20.67H.06c-.85,42.49,5.98,124.23,57.96,190.77,5.74,7.35,12.04,14.46,18.87,21.31,42.26,42.32,106.11,73.35,201.59,73.44,145.66.13,270.46-78.6,346.37-268.97,24.98.41,90.92,4.48,123.19-57.88.79-1.05,8.21-16.54,8.21-16.54l-12.3-8.27ZM189.67,206.39h-81.7v81.7h81.7v-81.7ZM295.22,206.39h-81.7v81.7h81.7v-81.7ZM400.77,206.39h-81.7v81.7h81.7v-81.7ZM506.32,206.39h-81.7v81.7h81.7v-81.7ZM84.12,206.39H2.42v81.7h81.7v-81.7ZM189.67,103.2h-81.7v81.7h81.7v-81.7ZM295.22,103.2h-81.7v81.7h81.7v-81.7ZM400.77,103.2h-81.7v81.7h81.7v-81.7ZM400.77,0h-81.7v81.7h81.7V0Z"
                                />
                            </g>

                            {/* Raam */}
                            <rect
                                className="door-window"
                                x={43.127083}
                                y={7.4083333}
                                width={8.9958334}
                                height={14.816667}
                                fill="#c2ddf1"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                        </g>

                    </g>

                    {/* Luik 1 */}
                    <g id="luik-1" className="hatch">
                        <rect
                            x={55.033333}
                            y={6.3499999}
                            width={13.229166}
                            height={0.79374999}
                            fill="#989898"
                            stroke="#000"
                            strokeWidth={0.264583}
                        />

                        <g clipPath="url(#clip-luik-1)">
                            {/* Achtergrond in luik */}
                            <rect
                                x={55.033333}
                                y={7.1437507}
                                width={13.229166}
                                height={30.956249}
                                fill="#fff"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />

                            {/* Legplank (achter rolluik) */}
                            <g id="plank-luik-1">
                                <rect x={55.4} y={24.0} width={12.5} height={0.6} fill="#d7d7d7" stroke="#9a9a9a" strokeWidth={0.12} />
                            </g>

                            {/* LOGO'S (onder elkaar) — achter het rolluik */}
                            <g id="logos-luik-1">
                                {/* Ruby logo */}
                                <g transform="translate(57 11) scale(0.015)">
                                    <path d="M387.37 329.1 101.9 498.61l369.63-25.08L500 100.82z" fill="#e2242a" fillRule="evenodd" />
                                    <path d="M472.14 473.28 440.37 254l-86.54 114.27z" fill="url(#_名称未設定グラデーション_3)" fillRule="evenodd" />
                                    <path d="M472.57 473.28 239.82 455l-136.68 43.14z" fill="url(#_名称未設定グラデーション_31)" fillRule="evenodd" />
                                    <path d="m103.47 498.18 58.14-190.48-127.95 27.36z" fill="#e62923" fillRule="evenodd" />
                                    <path d="m353.81 368.9-53.5-209.56L147.2 302.86z" fill="#e62923" fillRule="evenodd" />
                                    <path d="M487.86 162.29 343.13 44.09l-40.3 130.29z" fill="#e62923" fillRule="evenodd" />
                                    <path d="m420.18 1.94-85.12 47.04-53.7-47.67z" fill="#e62923" fillRule="evenodd" />
                                    <path d="m0 398.96 35.66-65.04-28.85-77.47z" fill="#e62923" fillRule="evenodd" />
                                    <path d="m4.9 254 29.02 82.32 126.1-28.29 143.97-133.8 40.63-129.05L280.65 0 171.88 40.71c-34.27 31.87-100.76 94.94-103.16 96.12C66.35 138.04 24.81 216.55 4.9 254" fill="#fcb19d" fillRule="evenodd" />
                                    <path d="M106.8 106.12c74.27-73.64 170.01-117.15 206.76-80.08 36.72 37.07-2.22 127.16-76.49 200.78-74.27 73.61-168.83 119.52-205.55 82.45-36.74-37.05 1.01-129.54 75.28-203.15" fill="#e2242a" fillRule="evenodd" />
                                    <path d="m103.47 498.11 57.69-191.09 191.59 61.55c-69.27 64.96-146.32 119.87-249.28 129.54" fill="#b8211c" fillRule="evenodd" />
                                    <path d="M304.24 173.85 353.42 368.67c57.87-60.84 109.8-126.26 135.24-207.16z" fill="url(#_名称未設定グラデーション_11)" fillRule="evenodd" />
                                    <path d="M488.16 162.49c19.68-59.41 24.23-144.63-68.59-160.45l-76.16 42.07 144.76 118.38Z" fill="#b8211c" fillRule="evenodd" />
                                    <path d="M0 398.1c2.73 98.04 73.46 99.51 103.59 100.37l-69.6-162.55z" fill="#b8211c" fillRule="evenodd" />
                                    <path d="M304.52 174.15c44.47 27.33 134.08 82.22 135.9 83.23 2.82 1.59 38.64-60.39 46.76-95.42z" fill="#cf251f" fillRule="evenodd" />
                                    <path d="m161.08 307.02 77.12 148.79c45.6-24.73 81.31-54.86 114.02-87.14z" fill="#cf251f" fillRule="evenodd" />
                                    <path d="M33.69 336.12 22.76 466.24c20.62 28.16 48.98 30.61 78.74 28.42-21.53-53.58-64.53-160.7-67.81-158.53Z" fill="#cf251f" fillRule="evenodd" />
                                    <path d="m342.96 44.44 153.21 21.5c-8.18-34.65-33.29-57.01-76.09-64z" fill="#cf251f" fillRule="evenodd" />
                                </g>

                                {/* Ruby on Rail logo */}
                                <g transform="translate(57 27) scale(0.06)">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        fill="#C00"
                                        d="M109.682 14.737c-12.206-6.023-24.708-6.636-37.508-2.111-11.779 4.164-21.175 11.615-28.16 21.763C32.195 51.561 23.61 70.298 18.799 90.652c-2.464 10.417-4.06 21.466-3.631 32.224.035.873.165 1.124.251 3.124h60.366c-.173-2-.287-1.416-.437-1.797a153.86 153.86 0 01-7.428-25.198c-2.498-12.251-3.806-24.729-1.226-37.093 3.611-17.313 13.48-29.805 30.117-36.283 9.424-3.667 18.369-2.624 26.214 4.262.072.063.22.025.412.056l2.565-3.883c-4.94-4.703-10.368-8.389-16.32-11.327zM3.336 94.394c-.46 3.923-.89 7.596-1.34 11.451l11.132 1.336 2.039-11.893-11.831-.894zm21.85-34.186l-10.471-4.097-3.384 9.607 10.671 3.42c1.08-3.031 2.096-5.882 3.184-8.93zm49.419 53.659c3.575.266 7.157.449 11.103.679-1.433-2.979-2.706-5.673-4.039-8.335-.146-.289-.639-.568-.974-.573-3.033-.044-6.068-.025-9.291-.025.726 2.628 1.357 5.053 2.096 7.443.111.361.707.782 1.105.811zM42.933 31.103l-7.955-5.268-6.359 7.105 8.178 5.496 6.136-7.333zm25.334 53.369c-.013.321.276.832.558.959 2.865 1.288 5.76 2.515 8.912 3.873-.131-2.492-.219-4.575-.368-6.654-.027-.374-.203-.912-.48-1.066-2.631-1.456-5.299-2.847-8.216-4.395-.159 2.665-.321 4.972-.406 7.283zM65.91 12.3l-5.446-6.181-7.499 3.898 5.455 6.644 7.49-4.361zm3.415 49.176c-.163.374.052 1.167.373 1.456 2.175 1.962 4.424 3.84 6.926 5.981.573-2.4 1.113-4.539 1.571-6.693.081-.383-.032-1.016-.298-1.23-1.946-1.569-3.955-3.063-6.037-4.651-.915 1.815-1.802 3.443-2.535 5.137zm12.45-52.424c2.78.075 5.563.042 8.499.042-.293-2.044-.433-3.593-.782-5.092-.104-.446-.775-1.04-1.228-1.078-2.787-.226-5.585-.313-8.651-.459.409 2.063.721 3.881 1.162 5.668.093.379.647.909 1 .919zm3.385 35.675c.142-.266.178-.749.029-.981-1.366-2.137-2.785-4.241-4.254-6.455l-4.76 4.372 6.582 7.294c.884-1.539 1.675-2.868 2.403-4.23zM90.295 30.2l2.843 5.281c4.449-2.438 4.875-3.32 3.3-6.834L90.295 30.2zm21.287-16.273c1.851 1.142 3.806 2.115 5.792 3.185l1.33-2.07c-2.422-1.771-4.76-3.484-7.413-5.426-.104 1.104-.259 1.875-.219 2.637.032.581.129 1.44.51 1.674zM109 30.646c2 .217 5 .424 7 .643v-2.718c-2-.438-5-.872-7-1.323v3.398z"
                                    />
                                </g>
                            </g>

                            {/* Rolluik (komt NA de logo's, dus logo's zitten erachter) */}
                            <rect
                                className="shutter shutter-1"
                                x={55.033333}
                                y={7.1437497}
                                width={13.229166}
                                height={30.956249}
                                fill="#b2b2b2"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                            <rect
                                className="shutter shutter-1 shutter-handle"
                                x={55.033333}
                                y={37.570831}
                                width={13.229166}
                                height={0.52916664}
                                fill="#989898"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                        </g>
                    </g>

                    {/* Luik 2 */}
                    <g id="luik-2" className="hatch">
                        <rect
                            x={69.585419}
                            y={6.3499999}
                            width={15.08125}
                            height={0.79374999}
                            fill="#989898"
                            stroke="#000"
                            strokeWidth={0.264583}
                        />

                        <g clipPath="url(#clip-luik-2)">
                            {/* Achtergrond in luik */}
                            <rect
                                x={69.585419}
                                y={7.1437502}
                                width={15.08125}
                                height={24.341667}
                                fill="#fff"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />

                            {/* Legplank (achter rolluik) */}
                            <g id="plank-luik-2">
                                <rect
                                    x={69.95}
                                    y={21.4}
                                    width={14.35}
                                    height={0.6}
                                    fill="#d7d7d7"
                                    stroke="#9a9a9a"
                                    strokeWidth={0.12} />
                            </g>

                            {/* LOGO'S (onder elkaar) — achter het rolluik */}
                            <g id="logos-luik-2">
                                {/* React logo */}
                                <g transform="translate(72 10) scale(0.0185)">
                                    <path
                                        fill="#58C4DC"
                                        fillRule="nonzero"
                                        d="M285.5,201 C255.400481,201 231,225.400481 231,255.5 C231,285.599519 255.400481,310 285.5,310 C315.599519,310 340,285.599519 340,255.5 C340,225.400481 315.599519,201 285.5,201"
                                    />
                                    <path
                                        fill="#58C4DC"
                                        fillRule="nonzero"
                                        d="M568.959856,255.99437 C568.959856,213.207656 529.337802,175.68144 466.251623,150.985214 C467.094645,145.423543 467.85738,139.922107 468.399323,134.521063 C474.621631,73.0415145 459.808523,28.6686204 426.709856,9.5541429 C389.677085,-11.8291748 337.36955,3.69129898 284.479928,46.0162134 C231.590306,3.69129898 179.282771,-11.8291748 142.25,9.5541429 C109.151333,28.6686204 94.3382249,73.0415145 100.560533,134.521063 C101.102476,139.922107 101.845139,145.443621 102.708233,151.02537 C97.4493791,153.033193 92.2908847,155.161486 87.3331099,157.39017 C31.0111824,182.708821 0,217.765415 0,255.99437 C0,298.781084 39.6220545,336.307301 102.708233,361.003527 C101.845139,366.565197 101.102476,372.066633 100.560533,377.467678 C94.3382249,438.947226 109.151333,483.32012 142.25,502.434597 C153.629683,508.887578 166.52439,512.186771 179.603923,511.991836 C210.956328,511.991836 247.567589,495.487529 284.479928,465.972527 C321.372196,495.487529 358.003528,511.991836 389.396077,511.991836 C402.475265,512.183856 415.36922,508.884856 426.75,502.434597 C459.848667,483.32012 474.661775,438.947226 468.439467,377.467678 C467.897524,372.066633 467.134789,366.565197 466.291767,361.003527 C529.377946,336.347457 569,298.761006 569,255.99437 M389.155214,27.1025182 C397.565154,26.899606 405.877839,28.9368502 413.241569,33.0055186 C436.223966,46.2772304 446.540955,82.2775015 441.522965,131.770345 C441.181741,135.143488 440.780302,138.556788 440.298575,141.990165 C414.066922,134.08804 387.205771,128.452154 360.010724,125.144528 C343.525021,103.224055 325.192524,82.7564475 305.214266,63.9661533 C336.586743,39.7116483 366.032313,27.1025182 389.135142,27.1025182 M378.356498,310.205598 C368.204912,327.830733 357.150626,344.919965 345.237759,361.405091 C325.045049,363.479997 304.758818,364.51205 284.459856,364.497299 C264.167589,364.51136 243.888075,363.479308 223.702025,361.405091 C211.820914,344.919381 200.80007,327.83006 190.683646,310.205598 C180.532593,292.629285 171.306974,274.534187 163.044553,255.99437 C171.306974,237.454554 180.532593,219.359455 190.683646,201.783142 C200.784121,184.229367 211.770999,167.201087 223.601665,150.764353 C243.824636,148.63809 264.145559,147.579168 284.479928,147.591877 C304.772146,147.579725 325.051559,148.611772 345.237759,150.68404 C357.109048,167.14607 368.136094,184.201112 378.27621,201.783142 C388.419418,219.363718 397.644825,237.458403 405.915303,255.99437 C397.644825,274.530337 388.419418,292.625022 378.27621,310.205598 M419.724813,290.127366 C426.09516,307.503536 431.324985,325.277083 435.380944,343.334682 C417.779633,348.823635 399.836793,353.149774 381.668372,356.285142 C388.573127,345.871232 395.263781,335.035679 401.740334,323.778483 C408.143291,312.655143 414.144807,301.431411 419.805101,290.207679 M246.363271,390.377981 C258.848032,391.140954 271.593728,391.582675 284.5,391.582675 C297.406272,391.582675 310.232256,391.140954 322.737089,390.377981 C310.880643,404.583418 298.10766,417.997563 284.5,430.534446 C270.921643,417.999548 258.18192,404.585125 246.363271,390.377981 Z M187.311556,356.244986 C169.137286,353.123646 151.187726,348.810918 133.578912,343.334682 C137.618549,325.305649 142.828222,307.559058 149.174827,290.207679 C154.754833,301.431411 160.736278,312.655143 167.239594,323.778483 C173.74291,334.901824 180.467017,345.864539 187.311556,356.285142 M149.174827,221.760984 C142.850954,204.473938 137.654787,186.794745 133.619056,168.834762 C151.18418,163.352378 169.085653,159.013101 187.211197,155.844146 C180.346585,166.224592 173.622478,176.986525 167.139234,188.210257 C160.65599,199.433989 154.734761,210.517173 149.074467,221.760984 M322.616657,121.590681 C310.131896,120.827708 297.3862,120.385987 284.379568,120.385987 C271.479987,120.385987 258.767744,120.787552 246.242839,121.590681 C258.061488,107.383537 270.801211,93.9691137 284.379568,81.4342157 C297.99241,93.9658277 310.765727,107.380324 322.616657,121.590681 Z M401.70019,188.210257 C395.196875,176.939676 388.472767,166.09743 381.527868,155.68352 C399.744224,158.819049 417.734224,163.151949 435.380944,168.654058 C431.331963,186.680673 426.122466,204.426664 419.785029,221.781062 C414.205023,210.55733 408.203506,199.333598 401.720262,188.230335 M127.517179,131.790423 C122.438973,82.3176579 132.816178,46.2973086 155.778503,33.0255968 C163.144699,28.9632474 171.455651,26.9264282 179.864858,27.1225964 C202.967687,27.1225964 232.413257,39.7317265 263.785734,63.9862316 C243.794133,82.7898734 225.448298,103.270812 208.949132,125.204763 C181.761691,128.528025 154.90355,134.14313 128.661281,141.990165 C128.199626,138.556788 127.778115,135.163566 127.456963,131.790423 M98.4529773,182.106474 C101.54406,180.767925 104.695358,179.429376 107.906872,178.090828 C114.220532,204.735668 122.781793,230.7969 133.498624,255.99437 C122.761529,281.241316 114.193296,307.357063 107.8868,334.058539 C56.7434387,313.076786 27.0971497,284.003505 27.0971497,255.99437 C27.0971497,229.450947 53.1907013,202.526037 98.4529773,182.106474 Z M155.778503,478.963143 C132.816178,465.691432 122.438973,429.671082 127.517179,380.198317 C127.838331,376.825174 128.259842,373.431953 128.721497,369.978497 C154.953686,377.878517 181.814655,383.514365 209.009348,386.824134 C225.500295,408.752719 243.832321,429.233234 263.805806,448.042665 C220.069,481.834331 180.105722,492.97775 155.838719,478.963143 M441.502893,380.198317 C446.520883,429.691161 436.203894,465.691432 413.221497,478.963143 C388.974566,493.017906 348.991216,481.834331 305.274481,448.042665 C325.241364,429.232737 343.566681,408.752215 360.050868,386.824134 C387.245915,383.516508 414.107066,377.880622 440.338719,369.978497 C440.820446,373.431953 441.221885,376.825174 441.563109,380.198317 M461.193488,334.018382 C454.869166,307.332523 446.294494,281.231049 435.561592,255.99437 C446.289797,230.744081 454.857778,204.629101 461.173416,177.930202 C512.216417,198.911955 541.942994,227.985236 541.942994,255.99437 C541.942994,284.003505 512.296705,313.076786 461.153344,334.058539"
                                    />
                                </g>

                                {/* TypeScript logo */}
                                <g transform="translate(74 24) scale(0.05)">
                                    <rect width="128" height="128" rx="6" fill="#3178c6" />
                                    <path
                                        fill="#fff"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="m74.2622 99.468v14.026c2.2724 1.168 4.9598 2.045 8.0625 2.629 3.1027.585 6.3728.877 9.8105.877 3.3503 0 6.533-.321 9.5478-.964 3.016-.643 5.659-1.702 7.932-3.178 2.272-1.476 4.071-3.404 5.397-5.786 1.325-2.381 1.988-5.325 1.988-8.8313 0-2.5421-.379-4.7701-1.136-6.6841-.758-1.9139-1.85-3.6159-3.278-5.1062-1.427-1.4902-3.139-2.827-5.134-4.0104-1.996-1.1834-4.246-2.3011-6.752-3.353-1.8352-.7597-3.4812-1.4975-4.9378-2.2134-1.4567-.7159-2.6948-1.4464-3.7144-2.1915-1.0197-.7452-1.8063-1.5341-2.3598-2.3669-.5535-.8327-.8303-1.7751-.8303-2.827 0-.9643.2476-1.8336.7429-2.6079s1.1945-1.4391 2.0976-1.9943c.9031-.5551 2.0101-.9861 3.3211-1.2929 1.311-.3069 2.7676-.4603 4.3699-.4603 1.1658 0 2.3958.0877 3.6928.263 1.296.1753 2.6.4456 3.911.8109 1.311.3652 2.585.8254 3.824 1.3806 1.238.5552 2.381 1.198 3.43 1.9285v-13.1051c-2.127-.8182-4.45-1.4245-6.97-1.819s-5.411-.5917-8.6744-.5917c-3.3211 0-6.4674.3579-9.439 1.0738-2.9715.7159-5.5862 1.8336-7.844 3.353-2.2578 1.5195-4.0422 3.4553-5.3531 5.8075-1.311 2.3522-1.9665 5.1646-1.9665 8.4373 0 4.1785 1.2017 7.7433 3.6052 10.6945 2.4035 2.9513 6.0523 5.4496 10.9466 7.495 1.9228.7889 3.7145 1.5633 5.375 2.323 1.6606.7597 3.0954 1.5486 4.3044 2.3668s2.1628 1.7094 2.8618 2.6736c.7.9643 1.049 2.06 1.049 3.2873 0 .9062-.218 1.7462-.655 2.5202s-1.1 1.446-1.9885 2.016c-.8886.57-1.9956 1.016-3.3212 1.337-1.3255.321-2.8768.482-4.6539.482-3.0299 0-6.0305-.533-9.0021-1.6-2.9715-1.066-5.7245-2.666-8.2591-4.799zm-23.5596-34.9136h18.2974v-11.5544h-51v11.5544h18.2079v51.4456h14.4947z"
                                    />
                                </g>
                            </g>

                            {/* Rolluik (NA de logo's, dus logo's zitten erachter) */}
                            <rect
                                className="shutter shutter-2"
                                x={69.585419}
                                y={7.1437497}
                                width={15.08125}
                                height={24.341667}
                                fill="#b2b2b2"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                            <rect
                                className="shutter shutter-2 shutter-handle"
                                x={69.585419}
                                y={30.956249}
                                width={15.08125}
                                height={0.52916533}
                                fill="#989898"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                        </g>
                    </g>


                    {/* Luik 3 */}
                    <g id="luik-3" className="hatch">
                        <rect
                            x={85.724998}
                            y={6.3499999}
                            width={12.964583}
                            height={0.79374999}
                            fill="#989898"
                            stroke="#000"
                            strokeWidth={0.264583}
                        />

                        <g clipPath="url(#clip-luik-3)">
                            {/* Achtergrond in luik */}
                            <rect
                                x={85.724998}
                                y={7.1437502}
                                width={12.964583}
                                height={30.956249}
                                fill="#fff"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />

                            {/* Legplank (achter rolluik) */}
                            <g id="plank-luik-3">
                                <rect
                                    x={86.05}
                                    y={24.0}
                                    width={12.3}
                                    height={0.6}
                                    fill="#d7d7d7"
                                    stroke="#9a9a9a"
                                    strokeWidth={0.12}
                                />
                            </g>

                            {/* LOGO'S (onder elkaar) — achter het rolluik */}
                            <g id="logos-luik-3">
                                {/* SQL Database logo */}
                                <g transform="translate(88 10) scale(0.5)">
                                    <g transform="matrix(1.0714286,0,0,1.0714286,-5.5751492,-1.9875771)">
                                        <path
                                            d="M 9.8548499,20.114679 C 8.5656786,19.834692 6.9190346,19.117176 6.3012886,18.566233 5.2430596,17.622449 5.2640556,17.773453 5.2654056,11.115525 5.2671056,4.1442491 5.4005241,4.0947113 6.6637514,3.2934092 8.2731698,2.4271209 9.8107609,1.9729835 12.564932,1.8716232 c 4.136778,-0.1522504 7.018332,0.7484839 8.302162,2.5951588 0.292001,0.4200011 0.326022,1.113339 0.326022,6.643521 0,6.663248 0.021,6.51222 -1.037132,7.45593 -0.638455,0.569413 -2.265691,1.265197 -3.640142,1.556468 -1.609419,0.341055 -5.072888,0.336897 -6.6609921,-0.0084 z M 15.124937,8.4485743 c 3.079174,-0.3991269 5.183238,-1.5514139 5.183238,-2.8385912 0,-1.877335 -4.634413,-3.397921 -8.748011,-2.8702736 -3.2949564,0.4226471 -5.4110674,1.545128 -5.4110674,2.8702736 0,1.2497972 2.141815,2.4566703 5.0232404,2.8304992 1.680132,0.217967 2.323347,0.219283 3.9526,0.0084 z"
                                            fill="#000"
                                        />
                                        <path
                                            d="m 6.6501138,14.159279 0.9301753,-0.09043 q 0.083974,0.468317 0.3391264,0.687942 0.2583821,0.219625 0.6944018,0.219625 0.4618579,0 0.6944017,-0.193787 0.2357736,-0.197016 0.2357736,-0.458628 0,-0.167948 -0.100123,-0.28422 Q 9.3469763,13.920275 9.1015134,13.833071 8.933565,13.774935 8.3360566,13.626366 7.56737,13.435809 7.2573116,13.158048 6.8212919,12.767245 6.8212919,12.205264 q 0,-0.361734 0.2034758,-0.675023 0.2067057,-0.316518 0.5910489,-0.481236 0.3875731,-0.164719 0.9334052,-0.164719 0.891418,0 1.3403568,0.390803 0.4521684,0.390803 0.4747774,1.043218 l -0.956014,0.04199 q -0.061366,-0.364965 -0.2648416,-0.523224 -0.200246,-0.161489 -0.603968,-0.161489 -0.416641,0 -0.6524146,0.171178 -0.1517995,0.109813 -0.1517995,0.29391 0,0.167948 0.1421102,0.28745 0.1808674,0.151799 0.8784989,0.316518 0.6976315,0.164719 1.0302984,0.342356 0.3358962,0.174408 0.5232232,0.481237 0.190557,0.303599 0.190557,0.752537 0,0.406952 -0.226084,0.762227 -0.226084,0.355276 -0.6394957,0.529684 -0.4134112,0.171178 -1.0302984,0.171178 -0.8978775,0 -1.3791141,-0.413412 -0.4812365,-0.416641 -0.5749,-1.211165 z"
                                            fill="#fff"
                                        />
                                        <path
                                            d="m 15.115355,15.099143 q 0.352046,0.251923 0.765457,0.400492 l -0.352045,0.675024 q -0.216395,-0.0646 -0.423101,-0.177638 -0.04522,-0.02261 -0.636266,-0.419871 -0.465087,0.203476 -1.030298,0.203476 -1.091664,0 -1.711781,-0.642725 -0.616887,-0.642726 -0.616887,-1.805445 0,-1.159489 0.620117,-1.802215 0.620117,-0.645955 1.682713,-0.645955 1.052906,0 1.669794,0.645955 0.616887,0.642726 0.616887,1.802215 0,0.613657 -0.171178,1.078745 -0.129191,0.355275 -0.413412,0.687942 z m -0.768686,-0.539372 q 0.184097,-0.216395 0.274531,-0.523224 0.09366,-0.306828 0.09366,-0.704091 0,-0.820363 -0.361735,-1.224085 -0.361735,-0.406951 -0.946324,-0.406951 -0.584589,0 -0.949554,0.406951 -0.361735,0.406952 -0.361735,1.224085 0,0.830052 0.361735,1.243464 0.364965,0.410181 0.920486,0.410181 0.206706,0 0.390803,-0.06782 -0.29068,-0.190557 -0.591049,-0.297139 l 0.268071,-0.545833 q 0.471548,0.161489 0.901108,0.484467 z"
                                            fill="#fff"
                                        />
                                        <path
                                            d="m 16.475091,15.699882 v -4.696094 h 0.956013 v 3.898339 h 2.377115 v 0.797755 z"
                                            fill="#fff"
                                        />
                                    </g>
                                </g>

                                {/* SketchUp logo */}
                                <g transform="translate(88 27) scale(0.07)">
                                    <g transform="matrix(1.1765787,0,0,1.1765787,4.9651637,-0.34120621)">
                                        <path
                                            fill="#005F9E"
                                            d="M 100.18,23.98 64.76,3.57 c 0,0 -5.61,-3.28 -14.56,-3.28 -9.32,0 -14.72,3.38 -14.72,3.38 l -32.8,18.77 49.9,28.68 v 57.96 L 85.42,90.33 c 0,0 5.87,-3.24 10.33,-10.94 3.93,-6.78 4.42,-13.34 4.42,-13.34 V 23.98 Z m -53.4,9.44 c 0,0 7.32,-1.35 13.51,2.22 6.19,3.57 9.84,5.67 9.84,5.67 0,0 0.01,4.97 0.01,12.4 0,5.95 -5.04,12.12 -5.04,12.12 L 65.12,44 Z M 75.8,81.3 65.11,87.43 v -5.75 l 8.32,-4.76 c 7.92,-5.71 9.23,-14.13 9.23,-17.05 L 82.63,34.01 59.94,20.95 c 0,0 -3.45,-2.26 -9.65,-2.26 -6.2,0 -9.58,2.09 -9.58,2.09 l -7.97,4.58 -5.03,-2.91 11.01,-6.29 c 0,0 4.31,-2.39 11.53,-2.39 6.63,0 11.79,2.59 11.79,2.59 l 25.62,14.8 -0.03,28.22 C 87.8,63.72 85.79,74.32 75.8,81.3 Z"
                                        />
                                        <path
                                            fill="#005F9E"
                                            d="M 0.17,41.21 35.15,61.28 35.12,67.26 15.22,55.85 2.7,62.97 35.1,81.64 35.12,87.4 0.41,67.43 c 0.09,2.34 2.21,9.55 6.27,15.13 4.12,5.65 8.82,8.05 8.82,8.05 l 32.08,18.47 V 54 L 0.2,26.79 Z"
                                        />
                                    </g>
                                </g>
                            </g>


                            <rect
                                className="shutter shutter-3"
                                x={85.724998}
                                y={7.1437497}
                                width={12.964583}
                                height={30.956249}
                                fill="#b2b2b2"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />

                            <rect
                                className="shutter shutter-3 shutter-handle"
                                x={85.724998}
                                y={37.570831}
                                width={12.964583}
                                height={0.52916664}
                                fill="#989898"
                                stroke="#000"
                                strokeWidth={0.264583}
                            />
                        </g>
                    </g>

                    {/* Zonneklep + flitsers */}
                    <g id="zonneklep">
                        <path
                            d="M 26.896729,5.328296 H 5.6099537 c 0,0 -1.6327368,1.1564596 -2.2098221,1.9520394 C 2.8801573,7.9971808 2.3464138,9.7191556 2.3464138,9.7191556 H 25.225478 c 0,0 0.929265,-1.3119906 1.207807,-2.0438006 0.278542,-0.7318099 0.463444,-2.347059 0.463444,-2.347059 z"
                            fill="#666"
                            stroke="#000"
                            strokeWidth={0.264583}
                        />
                        <ellipse className="blink-front blink-front-left" cx={5.9995966} cy={7.523726} rx={0.9170984} ry={0.65251511} fill="#fff" stroke="#999" strokeWidth={0.28247} />
                        <ellipse className="blink-front blink-front-right" cx={24.131323} cy={7.523726} rx={0.9170984} ry={0.65251511} fill="#f9f9f9" stroke="#999" strokeWidth={0.28247} />
                    </g>

                    {/* Koplampen (knipperen tegelijk) */}
                    <ellipse
                        className="blink-headlight"
                        cx={3.3821762}
                        cy={40.216667}
                        rx={1.3062148}
                        ry={0.74583602}
                        fill="#f9f9f9"
                        stroke="#999"
                        strokeWidth={0.360411}
                    />
                    <ellipse
                        className="blink-headlight"
                        cx={19.716908}
                        cy={40.216667}
                        rx={1.3062148}
                        ry={0.74583602}
                        fill="#f9f9f9"
                        stroke="#999"
                        strokeWidth={0.360411}
                    />
                </g>

                {/* ITonFire icon op de truck */}
                <g id="itonfire-sticker" transform="translate(47 30) scale(5)">
                    <g transform="translate(-34 -9)">
                        <path
                            style={{
                                fill: "#ffffff",
                                stroke: "#a89027",
                                strokeWidth: 0.065,
                                strokeLinecap: "round",
                                strokeMiterlimit: 4,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                                paintOrder: "fill markers stroke",
                            }}
                            d="m 33.998407,9.7447043 c 0.03994,-0.023965 0.190583,0.029546 0.285513,0.00182 0.06121,-0.017877 0.105975,-0.046072 0.160685,-0.085671 0.0317,-0.022941 0.06347,-0.072115 0.09423,-0.1291452 0.03788,-0.072581 0.04722,-0.096464 0.05488,-0.1402408 0.0097,-0.05531 0.0061,-0.1014261 -0.01164,-0.1491686 -0.01473,-0.039714 -0.03235,-0.059089 -0.04888,-0.053733 -0.0038,0.00123 -0.01793,0.012907 -0.03142,0.025954 -0.03017,0.029171 -0.04681,0.042064 -0.07071,0.054794 -0.02938,0.015649 -0.07233,0.025569 -0.08468,0.019556 -0.0081,-0.00394 -0.006,-0.012237 0.01518,-0.059912 0.03622,-0.08159 0.05293,-0.1354715 0.06103,-0.1968388 0.008,-0.060818 0.0026,-0.1359019 -0.01487,-0.204118 -0.01471,-0.057578 -0.05544,-0.1471546 -0.07018,-0.1543322 -0.01386,-0.00675 -0.02286,4.093e-4 -0.05594,0.044451 -0.02536,0.033767 -0.04477,0.052195 -0.07708,0.073163 -0.02715,0.017619 -0.09576,0.053416 -0.176503,0.09209 -0.160456,0.076851 -0.240205,0.1460744 -0.299824,0.2602504 -0.02228,0.042675 -0.03509,0.067896 -0.04018,0.1050345 -0.0364,0.2656222 0.136197,0.2508611 0.190831,0.3784723 0.0068,0.015871 7.87e-4,0.034639 -0.0043,0.05283 -0.04494,0.2231915 -0.03573,0.1604802 0.123838,0.064744 z"
                        />
                    </g>
                </g>
            </svg>

            <style>{`
                @media (prefers-reduced-motion: reduce) {
                    .door-window,
                    .shutter,
                    .blink-blue,
                    .blink-front,
                    .blink-headlight {
                    animation: none !important;
                    transition: none !important;
                    filter: none !important;
                    }
                }

                .is-paused .door-window,
                .is-paused .shutter,
                .is-paused .blink-blue,
                .is-paused .blink-front {
                    animation-play-state: paused !important;
                }

                .door-window,
                .shutter {
                    transform-box: fill-box;
                    transform-origin: center;
                }

                /* 10s timeline */
                .door-window {
                    animation: doorCycle 10s infinite;
                }
                @keyframes doorCycle {
                    0%, 20%, 85%, 100% { transform: translateY(0px); }
                    35%, 70% { transform: translateY(10px); }
                }

                .shutter-1 { animation: shutter1Cycle 10s infinite; }
                .shutter-2 { animation: shutter2Cycle 10s infinite; }
                .shutter-3 { animation: shutter3Cycle 10s infinite; }

                @keyframes shutter1Cycle {
                    0%, 22%, 85%, 100% { transform: translateY(0px); }
                    38%, 70% { transform: translateY(-34px); }
                }
                @keyframes shutter2Cycle {
                    0%, 24%, 85%, 100% { transform: translateY(0px); }
                    40%, 70% { transform: translateY(-28px); }
                }
                @keyframes shutter3Cycle {
                    0%, 26%, 85%, 100% { transform: translateY(0px); }
                    42%, 70% { transform: translateY(-34px); }
                }

                /* --- SEQUENCE: eerst koplampen, dan zonneklep-flitsers --- */
                /* zelfde cyclusduur voor beiden */
                .blink-headlight { animation: headlightSeq 2.4s infinite; }
                .blink-front     { animation: frontSeq 2.4s infinite; }

                /* Koplampen: vroeg in de cyclus */
                @keyframes headlightSeq {
                0%, 8%, 100% { filter: none; }
                1.5%, 3.5%, 5.5%, 7% {
                    filter:
                    drop-shadow(0 0 1.2px rgba(255,255,255,.98))
                    drop-shadow(0 0 3.2px rgba(255,235,160,.75));
                }
                }

                /* Zonneklep: pas later in de cyclus */
                @keyframes frontSeq {
                0%, 45%, 100% { filter: none; }
                47%, 49%, 53%, 55% {
                    filter:
                    drop-shadow(0 0 1.2px rgba(255,255,255,.98))
                    drop-shadow(0 0 3.4px rgba(255,220,120,.75));
                }
                }

                /* mini “stagger” rechts blijft oké, maar past binnen het late venster */
                .blink-front-right { animation-delay: 0.06s; }
                `
            }</style>
        </div >

    );
}
